export const ACTION_TYPES = {
  setConfiguratorActiveStatus: 'SET_CONFIGURATOR_ACTIVE_STATUS',
  setActiveModelIndex: 'SET_ACTIVE_MODEL_INDEX',
  updateImageProps: 'UPDATE_IMAGE_PROPS',
  updateConfiguratorActiveSelections: 'UPDATE_CONFIGURATOR_ACTIVE_SELECTIONS',
  updateFilterSelection: 'UPDATE_FILTER_SELECTION'
};